export default "__VITE_ASSET__4ReBKDSx__"